(function() {
    const btnId = "bss-b2b-net-term-button";
    const targetText = "Buy Now Pay Later";

    const changeText = () => {
        const btn = document.getElementById(btnId);
        if (btn && btn.textContent !== targetText) {
            btn.textContent = targetText;
            return true;
        }
        return false;
    };
    if (changeText()) return;

   
    const observer = new MutationObserver((_, obs) => {
        if (changeText()) {
            obs.disconnect(); 
        }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
})();